import Swiper, { Navigation, Pagination, Autoplay } from "swiper"

window.addEventListener('DOMContentLoaded', function(event){

	if(!body.classList.contains('home')) {
		initQuotesSwiper()
	}

})

function initQuotesSwiper() {

	const swiper = new Swiper(".swiper", {
		modules: [Navigation, Pagination, Autoplay],
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		autoHeight: true,
		pagination: {
		  el: '.swiper-pagination',
		  clickable: true,
		},
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
	})

}